import { Button, HeroBackground, ProductMain, useWindowWidth } from '@prishapolicy/shared/ui'
import { NextSeo } from 'next-seo'
import React from 'react'
import suretyBond from './suretyBond.png'
import { Faq, InsurersLogoComponent, KeyBenifits, KeyBenifitsCardData, RelatedPProducts, SuretyBondCards, SuretyBondCardsData, SuretyBondFaqList, SuretyBondForm, UpcomingTenders, WhyChoosePrisha } from '@prishapolicy/w3/ui'
import Marquee from 'react-fast-marquee'


export function SuretyBond() {
    const { isXl } = useWindowWidth();
    return (
        <div>
            <NextSeo
                title="Surety Bonds | PrishaPolicy"
                description="Secure your loved ones' future effortlessly. Explore tailored life insurance plans at PrishaPolicy."
            />
            <ProductMain color="teal">
                <HeroBackground backgroundImage={suretyBond.src} backgroundColor='' padding={false} className='bg-green-200 pb-[350px] xl:pb-24 pt-32 mb-[-340px] xl:mb-0'> <div className='flex container  items-center'>
                    <div className='grid grid-cols-1 xl:grid-cols-2 gap-10 items-center' >
                        <div className='flex flex-col gap-5 '>
                            <h1 className='font-medium text-title-6 sm:text-title-2'>
                                Surety Bonds Made Simple:
                            </h1>
                            <p className='font-bold text-[44px] sm:text-[72px]'>
                                Your Guide to <br />Financial Security
                            </p>
                            <h1 className='text-title-6 font-normal'>Strengthen your business relationships with the reliability of surety bonds</h1>
                            <div className='flex flex-col sm:flex-row gap-3'>
                                <Button theme='primary' variant='primary' text='Schedule a Meeting' onClick={() => {
                                    window.open('https://outlook.office.com/bookwithme/user/c6c562e08fc944a4aaea9db44f740875%40prishapolicy.com?anonymous', '_blank');
                                }} />
                            </div>
                        </div>
                        <div>
                            {isXl && <SuretyBondForm />}
                        </div>
                    </div>
                </div>
                </HeroBackground>
                {!isXl && <div className='container px-2'>
                    <SuretyBondForm />
                </div>}
                {!isXl ?
                    <Marquee speed={50} gradient={false} pauseOnHover={true} >
                        <InsurersLogoComponent />
                    </Marquee> : <InsurersLogoComponent />
                }

                <div className={`grid grid-cols-1 ${!isXl ? 'container' : 'px-5 sm:px-15'}  xl:grid-cols-2 gap-10  pt-5 pb-15`}>
                    {SuretyBondCardsData && SuretyBondCardsData.map((bond, idx) =>
                        <div key={idx}>
                            <SuretyBondCards title={bond.title} description={bond.description} imageUrl={bond.imageUrl} theme={bond.theme} />
                        </div>
                    )}
                </div>
                <div className={` pt-5 pb-15  ${!isXl ? 'container' : 'px-5 sm:px-15'}`}>
                    <KeyBenifits KeyBenifitsData={KeyBenifitsCardData} />
                </div>
                <UpcomingTenders />
                <WhyChoosePrisha />
                <RelatedPProducts />

            </ProductMain>
            <div className='w-full'>

                <Faq list={SuretyBondFaqList} />
            </div>
        </div>
    )
}

export default SuretyBond;
